export default __webpack_public_path__ + "static/media/favorite.fd3af1aa.svg";